"use client";
import Image from "next/image";
import TopCard from "./top-card";
import React, { useState } from "react";
import DetailsCard from "./details-card";
import EmiDetailsCard from "./emi-details-card";
import FileSelectModal from "./file-select-modal";
import { Stack, Typography } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import { useGetCustomerQuery, useGetLoanDetailsQuery } from "@/lib/redux";
import {
  Add72hours,
  IMAGES,
  IsDifferenceGreaterThan72Hours,
  WEB_COLORS,
} from "@/lib/constants";
import InsuranceDetailsCard from "./Insurance-details-card";
import { ButtonComponent, ModalComponent, PaperComponent } from "@/components";

const LoanDetails = ({ appId }) => {
  const { data: loanDetailsData } = useGetLoanDetailsQuery(appId);
  const [openCancelLoanModal, setOpenCancelLoanModal] = useState(false);
  const { data: customerData } = useGetCustomerQuery("", {
    refetchOnMountOrArgChange: true,
  });
  const loanDetails = loanDetailsData?.data?.loansdetails;
  const [openFileModal, setOpenFileModal] = useState(false);

  const sendEmail = () => {
    const to = "loan.cancellation@herofincorp.com";
    const subject = `Request for Loan Cancellation Within Cool-Off Period ${loanDetails?.loan_details?.loanNumber}`;
    const body = `Dear Hero FinCorp Team,

I hope this message finds you well.

I am writing to formally request the cancellation of my loan under the cool-off period, during which I understand no penalties or charges will be applicable.\n

Here are the relevant details for your reference:\n

Loan Account Number: ${loanDetails?.loan_details?.loanNumber}
Application ID: ${appId}
Registered Mobile Number: ${customerData?.data?.phone}
Reason for Cancellation (write your reason):\n
Please treat this request as urgent and confirm the next steps at your earliest convenience.\n
Thank you for your assistance.`;

    const emailUrl = `mailto:${to}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    return emailUrl;
  };

  return (
    <PaperComponent>
      <Stack gap={2}>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Stack direction={"row"}>
            <Typography variant="h4">Loan Details</Typography>
          </Stack>
          <Stack>
            <ButtonComponent
              endIcon={<ChevronRight />}
              onClick={() => setOpenFileModal(true)}
            >
              View Documents
            </ButtonComponent>
          </Stack>
        </Stack>
        <TopCard {...loanDetails?.loan_details} {...loanDetails?.emi_details} />
        <DetailsCard {...loanDetails?.loan_details} />
        <EmiDetailsCard {...loanDetails?.emi_details} />
        {loanDetails?.insurance_details && (
          <InsuranceDetailsCard {...loanDetails?.insurance_details} />
        )}
        <PaperComponent>
          <Stack
            direction={"row"}
            gap={2}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            Transaction History
            <ChevronRight />
          </Stack>
        </PaperComponent>
        {IsDifferenceGreaterThan72Hours(
          loanDetails?.loan_details?.disbursedDate
        ) && (
          <PaperComponent
            paperStyle={{
              cursor: "pointer",
              "&:hover": {
                cursor: "pointer",
                backgroundColor: `#f6f6f6`,
              },
            }}
            onClick={() => setOpenCancelLoanModal(true)}
          >
            <Stack>
              <Stack
                direction={"row"}
                gap={3}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                Loan Cancellation
                <ChevronRight />
              </Stack>
              <Stack direction={"row"} gap={1} alignItems={"center"}>
                <Image src={IMAGES.infoIcon} alt="info" />
                <Typography variant="caption" color={WEB_COLORS.textFadeColor}>
                  You can cancel your loan within the{" "}
                  <strong style={{ color: "#000" }}>3-day</strong> cooling-off
                  period.
                </Typography>
              </Stack>
              <Typography variant="subtitle2" color={WEB_COLORS.errorColor}>
                Valid Till:{" "}
                {Add72hours(loanDetails?.loan_details?.disbursedDate)}
              </Typography>
            </Stack>
          </PaperComponent>
        )}
      </Stack>
      <ModalComponent
        open={openCancelLoanModal}
        handleModal={setOpenCancelLoanModal}
        title={"Loan Cancellation"}
      >
        <Stack gap={2} alignItems={"center"} flexGrow={1}>
          <Image src={IMAGES.loanCancellation} alt="Loan Cancellation" />
          <Stack justifyContent={"center"} alignItems={"center"} gap={2}>
            <Typography>Cancel Loan Request</Typography>
            <Typography
              variant="caption"
              align="center"
              color={WEB_COLORS.textFadeColor}
            >
              Please request for loan cancellation through a mail from your
              registered email id to{" "}
            </Typography>

            <a
              style={{
                color: WEB_COLORS.primary,
                fontSize: "12px",
                fontWeight: "bold",
                textDecoration: "underline",
                cursor: "pointer",  
              }}
              href={sendEmail()}
              target="_blank"
              rel="noopener noreferrer"
            >
              loan.cancellation@herofincorp.com
            </a>
          </Stack>
          <Stack
            bgcolor={WEB_COLORS.pale}
            direction={"row"}
            gap={2}
            p={2}
            width={"100%"}
            justifyContent={{ xs: "center", sm: "start" }}
          >
            <Stack>
              <Typography variant="caption" fontWeight={"bold"}>
                In the mail, please mention below points:
              </Typography>
              <Typography variant="caption">
                a. Reason of cancelling the loan
              </Typography>
              <Typography variant="caption">
                b. Loan Account Number (LAN) and App ID
              </Typography>
              <Typography variant="caption">
                c. Registered mobile number
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </ModalComponent>
      <FileSelectModal
        appId={appId}
        open={openFileModal}
        handleModal={setOpenFileModal}
      />
    </PaperComponent>
  );
};

export default LoanDetails;
